const DEFAULT_LANG = 'ja';
const PREFIXED_LANGS = ['en', 'zh-tw'];
const LABELS = { ja: 'JP', en: 'EN', 'zh-tw': 'TC' };

class LangSelector {
	constructor( $dom ){
		this.dom          	= $dom;
		this.button       	= $dom.querySelector("[data-select-lang]");
		this.currentLang  	= this.button.querySelector(".current_lang");
		this.links        	= $dom.querySelectorAll("a[data-lang]");
		// bind したものを保持しないと remove できない
		this.onClick 	= this.showSelector.bind(this);
		this.update();
		this.bind();
	}

	update(){
		const segments = location.pathname.split("/").filter(Boolean);
		const lang = PREFIXED_LANGS.includes(segments[0]) ? segments[0] : DEFAULT_LANG;
		const rest = lang === DEFAULT_LANG ? segments : segments.slice(1);

		this.dom.dataset.currentLang = lang;
		if( this.currentLang ) this.currentLang.textContent = LABELS[lang];

		this.links.forEach( ($a) => {
			const target = $a.dataset.lang;
			$a.href = this.buildUrl(target, rest);
			if( target === lang ){
				$a.setAttribute("aria-current", "true");
			}else{
				$a.removeAttribute("aria-current");
			}
		});
	}

	buildUrl( lang, rest ){
		// トップページ: ja は "/"、他言語は "/en"（末尾スラッシュなし）
		if( rest.length === 0 ){
			return lang === DEFAULT_LANG ? "/" : `/${lang}`;
		}
		// 下層ページ: 末尾スラッシュあり
		const base = `/${rest.join("/")}/`;
		return lang === DEFAULT_LANG ? base : `/${lang}${base}`;
	}

	bind(){
		this.button.removeEventListener("click", this.onClick, false);
		this.button.addEventListener("click", this.onClick, false);
	}

	showSelector(e){
		e.preventDefault();
		this.dom.classList.toggle("is-open");
	}
}

export let langSelectors = {
	arry: [],
	init: function(){
		let $langs = document.querySelectorAll(".c-lang_selector");
		langSelectors.arry = [];
		$langs.forEach( ($l, index) => {
			langSelectors.arry[index] = new LangSelector($l);
		});
		langSelectors.nav();
	},
	nav: function(){
		document.removeEventListener("click", langSelectors.onDocumentClick, false);
		document.addEventListener("click", langSelectors.onDocumentClick, false);
		document.removeEventListener("keydown", langSelectors.onKeydown, false);
		document.addEventListener("keydown", langSelectors.onKeydown, false);
	},
	onDocumentClick: function(e){
		// クリックされた要素が属しているセレクタ（外なら null）
		const $inside = e.target.closest(".c-lang_selector");
		langSelectors.close($inside);
	},
	onKeydown: function(e){
		if( e.key === "Escape" ) langSelectors.close();
	},
	close: function( $except ){
		document.querySelectorAll(".c-lang_selector.is-open").forEach( ($l) => {
			if( $l !== $except ) $l.classList.remove("is-open");
		});
	}
}